// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* .print_content {width: 96%; border: none; border-radius: inherit; padding:10px !important; margin: 20px auto 20px !important;}\n.popup_wrap {border-radius: none !important; box-shadow: none !important; padding: 20px;} */\nimg[data-v-1ab5e002] {width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
